const SEARCH = {
  SEARCH_ITEMS_INIT: 'SEARCH_ITEMS_INIT',
  SEARCH_ITEMS_SUCCESS: 'SEARCH_ITEMS_SUCCESS',
  SEARCH_ITEMS_FAILURE: 'SEARCH_ITEMS_FAILURE',
};

export default SEARCH;
